// extracted by mini-css-extract-plugin
module.exports = {"next":"nextsection-module--next--1xfQU","wiggle":"nextsection-module--wiggle--3ckXp"};